import { queryKeys } from '@/react-query/constants';
import { createFeatureApi, createQueryKeys } from '@/shared/api';

/**
 * The services feature roots on queryKeys.services (service list/detail + add/update/delete).
 * `suppliersKeys` is a DISTINCT root for the supplier pivot reads (kept separate as today).
 * Both INTERNAL — consumers use the exported hooks.
 */
export const servicesApi = createFeatureApi(queryKeys.services);
export const suppliersKeys = createQueryKeys(queryKeys.serviceSuppliers);
